import { Box, styled } from "@mui/material";

export const StyledQrScanner = styled(Box)(({ theme }) => ({
  ".cameraWrapper": {
    width: "30rem",
    position: "relative",
    height: "30rem",
    background: theme.contrast.lighter,
    borderRadius: "25px",
    overflow: "hidden",
    ".camera": {
        position:"absolute",
        width: "100%",
        height: "100%",
        opacity: "0.7",
        zIndex: "98"
    },
    ".camerabrackets": {
      position: "absolute",
      zIndex: "99",
      top: "50%",
      left: "50%",
      width: "80%",
      height: "80%",
      transform: "translate(-50%, -50%)",
      pointerEvents: "none",
      ".bracket-1": {
        position: "absolute",
        background: theme.color.main,
        width: "50px",
        height: "5px",
        borderRadius: "25px",
      },
      ".bracket-2": {
        position: "absolute",
        background: theme.color.main,
        width: "5px",
        height: "50px",
        borderRadius: "25px",
      },
      ".topleft": {
        top: "0",
        left: "0",
      },
      ".topright": { top: "0", right: "0" },
      ".bottomleft": { bottom: "0", left: "0" },
      ".bottomright": { bottom: "0", right: "0" },
    },
  },
}));
